export default __webpack_public_path__ + "static/media/camera_click.33384a00.wav";